import { formatPriceToman } from './formatPriceToman';

/** نمایش مبلغ در ماژول Work */
export const formatWorkPriceDisplay = (value, { empty = '—', suffix } = {}) => {
  if (value == null || value === '') return empty;
  const raw = String(value).replace(/,/g, '');
  if (raw === '' || Number.isNaN(Number(raw))) return String(value);
  const num = Number(raw);
  if (!num) return empty;
  return formatPriceToman(num, { emptyLabel: empty, currencySymbol: suffix });
};
